import {AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {PortfolioService} from "./portfolio-service.service";
import {Icontypes, PortfolioItem} from "./portfolio.datatypes";
import * as $ from 'jquery';
import * as fancybox from '@fancyapps/fancybox';
import {GoogleAnalyticsEventsService} from "../google-analytics-service";

interface IFancyBoxItem {
    src: string;
    type?: string;
    opts?: Object;
}

@Component({
    selector: 'app-portfolio-item',
    templateUrl: './portfolio-item.component.html',
    styleUrls: ['./portfolio-item.component.css'],
    providers: [
        PortfolioService
    ]
})

export class PortfolioItemComponent implements OnInit, AfterViewInit {
    @Input() project: PortfolioItem;
    @Input() config: any;
    slides: Array<string>;
    trustedURL: string;
    frmW: number;
    frmH: number;
    private frmAspect: number;
    itmReady: boolean;
    icons: Array<Icontypes>;
    technologies: Array<string>;
    tech1: Array<string>;
    tech2: Array<string>;
    isIframe = '';
    private iframeDiv;
    private resizeID;
    private iframeItem;

    constructor(private gaEventService: GoogleAnalyticsEventsService) {
        this.itmReady = false;
    }

    ngOnInit() {
        this.initPortfolioItem(this.project);
        let f = fancybox;
    }

    ngAfterViewInit() {
        if (this.project.assetsType == 'iframe') {
            this.frmAspect = this.frmH / this.frmW;
            this.iframeDiv = $(`.${this.isIframe}`);
            this.iframeItem = $(this.iframeDiv).find('.iframe-item');
            this.setIframeSize();
        }
    }

    private initPortfolioItem(item: PortfolioItem) {
        this.project = item;

        let icons = this.project.icons.split(',');
        this.icons = [];
        for (let i = 0; i < icons.length; i++) {
            let k = icons[i];
            this.icons.push({id: k, description: this.config.icons[k]});
        }

        this.technologies = this.project.technologies.split(",");
        this.tech1 = [];
        this.tech2 = [];
        if (this.technologies.length > 5) {
            let x = Math.ceil(this.technologies.length * .5);
            for (let i = 0; i < x; i++) {
                this.tech1.push(this.technologies.splice(0, 1)[0]);
            }
            x = this.technologies.length;
            for (let i = 0; i < x; i++) {
                this.tech2.push(this.technologies.splice(0, 1)[0]);
            }
        }

        switch (this.project.assetsType) {
            case 'snap' :
                break;
            case 'pics' :
                this.slides = [];
                for (let i = 1; i <= this.project.assetsQty; i++) {
                    this.slides.push("/portfolio/slides/" + this.project.assets + "/slide_" + i + ".jpg");
                }
                break;
            case 'iframe' :
                this.trustedURL = this.project.assets;
                let params = this.project.assetsSize.split(",");
                this.frmW = parseInt(params[0]);
                this.frmH = parseInt(params[1]);
                this.isIframe = 'hasiframe-' + this.project.id;
        }
    }

    imgLoaded() {
        this.itmReady = true;
    }

    openSlides(slides: string[]) {
        let fbItems: IFancyBoxItem[] = [];
        for (let i = 0; i < slides.length; i++) {
            fbItems.push({src: slides[i]});
        }

        let fb = $['fancybox'].open(fbItems, {loop: true, toolbar: false});

        this.gaEventService.emitEvent('viewSlides', this.project.job);
    }

    openExternal(url: string) {
        window.open(url, '_blank');
        this.gaEventService.emitEvent('viewExternal', this.project.job);
    }

    openWndo(asset: string, size: string) {
        let s = size.split(',');
        let w, h;
        if (s.length > 1) {
            w = Number(s[0]);
            h = Number(s[1]);
        }

        $['fancybox'].open(
            [
                {
                    src: asset
                }
            ]
        );

        this.gaEventService.emitEvent('viewWindow', this.project.job);
    }

    @HostListener('window:resize')
    onResize() {
        if (this.project.assetsType == 'iframe') {
            clearTimeout(this.resizeID);
            this.resizeID = setTimeout(() => {
                this.setIframeSize();
            }, 500);
        }
    }

    setIframeSize() {
        this.frmW = $(this.iframeDiv).innerWidth() - 20;
        this.frmH = this.frmW * this.frmAspect;
        $(this.iframeItem).width(this.frmW);
        $(this.iframeItem).height(this.frmH);
    }
}



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio-item.component.ts